/** Phase: Trade in-app chat — ko/en/vi/ru */

const trade = {
  myListings: [
    '내 판매',
    'My listings',
    'Tin của tôi',
    'Мои объявления',
  ],
  emptyHint: [
    '첫 상품을 올려보세요.',
    'List your first item.',
    'Hãy đăng sản phẩm đầu tiên.',
    'Разместите первый товар.',
  ],
  emptyAction: [
    '상품 등록',
    'List an item',
    'Đăng sản phẩm',
    'Добавить товар',
  ],
};

const productDetail = {
  chatWithSeller: [
    '판매자와 채팅',
    'Chat with seller',
    'Chat với người bán',
    'Чат с продавцом',
  ],
  chatInquiry: [
    '채팅 문의',
    'Chat inquiry',
    'Nhắn tin',
    'Написать в чат',
  ],
  likeToggleFailed: [
    '찜 처리에 실패했어요. 잠시 후 다시 시도해 주세요.',
    'Could not update your save. Please try again.',
    'Không thể cập nhật mục đã lưu. Vui lòng thử lại.',
    'Не удалось обновить избранное. Попробуйте снова.',
  ],
};

const chat = {
  unknownUser: ['사용자', 'User', 'Người dùng', 'Пользователь'],
};

/** Chat inbox tab label: business → "거래/Trade" (room_type/filter logic unchanged) */
const chatTabs = {
  business: ['거래', 'Trade', 'Giao dịch', 'Сделки'],
};

const chatRoom = {
  sellerContactsTitle: [
    '판매자 연락처 (참고)',
    'Seller contact (reference)',
    'Liên hệ người bán (tham khảo)',
    'Контакт продавца (справка)',
  ],
  contactKakao: ['카카오톡: {value}', 'KakaoTalk: {value}', 'KakaoTalk: {value}', 'KakaoTalk: {value}'],
  contactWhatsapp: ['WhatsApp: {value}', 'WhatsApp: {value}', 'WhatsApp: {value}', 'WhatsApp: {value}'],
  contactZalo: ['Zalo: {value}', 'Zalo: {value}', 'Zalo: {value}', 'Zalo: {value}'],
  contactPhone: ['전화: {value}', 'Phone: {value}', 'Điện thoại: {value}', 'Телефон: {value}'],
  contactCopied: [
    '연락처를 복사했어요.',
    'Contact copied.',
    'Đã sao chép liên hệ.',
    'Контакт скопирован.',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    trade: pick(trade, langIndex),
    productDetail: pick(productDetail, langIndex),
    chat: {
      ...pick(chat, langIndex),
      tabs: pick(chatTabs, langIndex),
      room: pick(chatRoom, langIndex),
    },
  };
}

export const phaseTradeChatKo = buildLang(0);
export const phaseTradeChatEn = buildLang(1);
export const phaseTradeChatVi = buildLang(2);
export const phaseTradeChatRu = buildLang(3);
